(function () {
  const instances = new Map();
  const MOBILE_MQ = '(max-width: 989px)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function parseDelay(section) {
    const delay = parseInt(section.getAttribute('data-delay'), 10);
    return Number.isFinite(delay) && delay > 0 ? delay : 5000;
  }

  function autoplayEnabled(section) {
    if (prefersReducedMotion()) return false;
    return section.getAttribute('data-autoplay') === 'true';
  }

  function autoplayConfig(section) {
    if (!autoplayEnabled(section)) return false;
    return {
      delay: parseDelay(section),
      disableOnInteraction: false,
    };
  }

  function updateTabs(section, index) {
    const tabs = Array.from(section.querySelectorAll('[data-tab]'));
    tabs.forEach(function (tab, i) {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    window.requestAnimationFrame(function () {
      updateIndicator(section, index);
    });
  }

  function updateIndicator(section, index) {
    const indicator = section.querySelector('[data-tab-indicator]');
    const tabs = Array.from(section.querySelectorAll('[data-tab]'));
    const active = tabs[index] || tabs[0];
    if (!indicator || !active) return;

    indicator.style.top = active.offsetTop + 'px';
    indicator.style.height = active.offsetHeight + 'px';
  }

  function destroySwiper(swiper) {
    if (!swiper) return;
    try {
      swiper.destroy(true, true);
    } catch (e) {
      /* ignore */
    }
  }

  function bindTabs(section) {
    const list = section.querySelector('[data-tab-list]');
    if (!list || list.getAttribute('data-bound') === 'true') return;

    list.setAttribute('data-bound', 'true');
    list.addEventListener('click', function (event) {
      const tab = event.target.closest('[data-tab]');
      if (!tab || !list.contains(tab)) return;

      const index = parseInt(tab.getAttribute('data-tab-index'), 10) || 0;
      const instance = instances.get(section);
      if (instance && instance.desktopSwiper && typeof instance.desktopSwiper.slideTo === 'function') {
        instance.desktopSwiper.slideTo(index);
      }
    });
  }

  function createDesktopSwiper(section, container) {
    if (!window.XBLOOM3 || !window.XBLOOM3.Swiper) return null;
    if (!container) return null;
    if (container.swiper) destroySwiper(container.swiper);

    return new window.XBLOOM3.Swiper(container, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      slidesPerView: 1,
      speed: prefersReducedMotion() ? 0 : 500,
      loop: false,
      rewind: true,
      allowTouchMove: true,
      grabCursor: true,
      autoplay: autoplayConfig(section),
      on: {
        slideChange: function () {
          updateTabs(section, this.realIndex);
        },
        init: function () {
          updateTabs(section, this.realIndex || 0);
        },
      },
    });
  }

  function createMobileSwiper(section, container) {
    if (!window.XBLOOM3 || !window.XBLOOM3.Swiper) return null;
    if (!container) return null;
    if (container.swiper) destroySwiper(container.swiper);

    const slideCount = container.querySelectorAll('.swiper-slide').length;
    const canLoop = slideCount > 1;

    return new window.XBLOOM3.Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: prefersReducedMotion() ? 0 : 400,
      loop: canLoop,
      loopedSlides: canLoop ? slideCount : 0,
      rewind: false,
      grabCursor: true,
      slidesOffsetAfter: 20,
      watchOverflow: true,
      autoplay: autoplayConfig(section),
    });
  }

  function syncSwiper(section) {
    const instance = instances.get(section);
    if (!instance) return;

    const mobile = isMobile();

    if (mobile) {
      if (instance.desktopSwiper) {
        destroySwiper(instance.desktopSwiper);
        instance.desktopSwiper = null;
      }
      if (!instance.mobileSwiper) {
        instance.mobileSwiper = createMobileSwiper(section, instance.mobileContainer);
      }
    } else {
      if (instance.mobileSwiper) {
        destroySwiper(instance.mobileSwiper);
        instance.mobileSwiper = null;
      }
      if (!instance.desktopSwiper) {
        instance.desktopSwiper = createDesktopSwiper(section, instance.desktopContainer);
      } else {
        updateIndicator(section, instance.desktopSwiper.realIndex || 0);
      }
    }
  }

  function destroy(section) {
    const instance = instances.get(section);
    if (!instance) return;

    if (instance.mq && instance.onMqChange) {
      if (instance.mq.removeEventListener) {
        instance.mq.removeEventListener('change', instance.onMqChange);
      } else if (instance.mq.removeListener) {
        instance.mq.removeListener(instance.onMqChange);
      }
    }

    destroySwiper(instance.desktopSwiper);
    destroySwiper(instance.mobileSwiper);
    instances.delete(section);
  }

  function init(section) {
    if (!section || instances.has(section)) return;

    const desktopContainer = section.querySelector('[data-desktop-swiper]');
    const mobileContainer = section.querySelector('[data-mobile-swiper]');
    if (!desktopContainer && !mobileContainer) return;

    const mq = window.matchMedia(MOBILE_MQ);
    const instance = {
      desktopContainer: desktopContainer,
      mobileContainer: mobileContainer,
      desktopSwiper: null,
      mobileSwiper: null,
      mq: mq,
      onMqChange: null,
    };

    instances.set(section, instance);
    bindTabs(section);

    instance.onMqChange = function () {
      syncSwiper(section);
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', instance.onMqChange);
    } else if (mq.addListener) {
      mq.addListener(instance.onMqChange);
    }

    syncSwiper(section);
  }

  function initAll(context) {
    const root = context || document;

    if (root.classList && root.classList.contains('feature-image-tabs')) {
      init(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.feature-image-tabs') : [];
    sections.forEach(init);
  }

  function waitForSwiper(attempt) {
    if (window.XBLOOM3 && window.XBLOOM3.Swiper) {
      initAll(document);
      return;
    }

    if (attempt > 20) return;
    setTimeout(function () {
      waitForSwiper(attempt + 1);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(0);
    });
  } else {
    waitForSwiper(0);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target;

    if (root.classList && root.classList.contains('feature-image-tabs')) {
      destroy(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.feature-image-tabs') : [];
    sections.forEach(destroy);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const sectionEl = event.target.closest ? event.target.closest('.feature-image-tabs') : null;
    if (!sectionEl) return;

    const instance = instances.get(sectionEl);
    if (!instance) return;

    const tab = event.target.closest('[data-tab]');
    const slide = event.target.closest('.swiper-slide');
    let index = 0;

    if (tab) {
      index = parseInt(tab.getAttribute('data-tab-index'), 10) || 0;
    } else if (slide) {
      const realIndex = slide.getAttribute('data-swiper-slide-index');
      if (realIndex !== null) {
        index = parseInt(realIndex, 10) || 0;
      } else if (slide.parentElement) {
        index = Array.from(slide.parentElement.children).indexOf(slide);
        if (index < 0) index = 0;
      }
    } else {
      return;
    }

    const swiper = isMobile() ? instance.mobileSwiper : instance.desktopSwiper;
    if (swiper && swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(index);
    } else if (swiper && typeof swiper.slideTo === 'function') {
      swiper.slideTo(index);
    }
  });

  window.addEventListener('resize', function () {
    instances.forEach(function (_instance, section) {
      if (!isMobile()) {
        const swiper = _instance.desktopSwiper;
        updateIndicator(section, swiper ? swiper.realIndex || 0 : 0);
      }
    });
  });
})();
